import React, { useEffect, useState } from "react";
import {
  IonCol,
  IonContent,
  IonHeader,
  IonModal,
  IonPopover,
  IonRow,
  IonTitle,
  IonToolbar,
} from "@ionic/react";
import StyledButton from "../StyledButton/StyledButton";
import dayjs from "dayjs";
import "dayjs/locale/es";
import { useSession } from "../../hooks/SessionContext";

import http from "../../hooks/httpAdapter";
import { useHistory } from "react-router";
import { CalendarPicker } from "../CalendarPicker/CalendarPicker";
import { obtenerNombreDia } from "../../utils/funcionalidadesStrings";

interface ContainerProps {
  fechasFuturas: string[];
  fechaSeleccionada: string;
  handleChangeFecha: (value: string) => void;
}
const ModalCalendarioPicker: React.FC<ContainerProps> = ({
  fechasFuturas,
  fechaSeleccionada,
  handleChangeFecha,
}) => {
  const { hcUL, cargandoSession, pacienteCargado, setSesionInvalida, mostrarNotificacion } =
    useSession();

  return (
    <>
      <StyledButton expand="full" id="calendar-button-trigger">
        {fechaSeleccionada !== ""
          ? `${obtenerNombreDia(dayjs(fechaSeleccionada).format("dddd"))} ${dayjs(
              fechaSeleccionada
            ).format("DD")} de ${dayjs(fechaSeleccionada).format("MMMM, YYYY")}`
          : `${obtenerNombreDia(dayjs().format("dddd"))} ${dayjs().format(
              "DD"
            )} de ${dayjs().format("MMMM, YYYY")}`}
      </StyledButton>
      <IonPopover trigger="calendar-button-trigger" triggerAction="click">
        <IonContent>
          <CalendarPicker
            fechasFuturas={fechasFuturas}
            fechaSeleccionada={fechaSeleccionada}
            handleChangeFecha={handleChangeFecha}
          />
        </IonContent>
      </IonPopover>
    </>
  );
};

export default ModalCalendarioPicker;
